import { FC, useRef, useEffect, useState } from 'react'

type InputTouchedStateProps = {
  onChange: (isTouched: boolean) => void
}
export const InputTouchedState: FC<InputTouchedStateProps> = (props) => {
  const { children, onChange } = props

  const [isTouched, setIsTouched] = useState(false)

  const rootRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    const { current } = rootRef
    if (!current || isTouched) {
      return
    }

    const handle = () => {
      setIsTouched(true)
      onChange(true)
    }
    current.addEventListener('focusin', handle, true)

    return () => {
      current.removeEventListener('focusin', handle, true)
    }
  }, [isTouched, onChange])

  return (
    <div ref={ rootRef }>
      { children }
    </div>
  )
}
